// extracted by mini-css-extract-plugin
export default {"container":"styles-scoped__container--sUSlh"};